import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield}}\n",{ moduleName: "garaje/pods/components/ui/classic/settings-panel/sp-header/sp-blank/template.hbs" })